module.exports = __webpack_public_path__ + "static/media/huffpost.581e3584.png";